<template>
  <div class="modal" tabindex="-1" id="modalLottery">

    <!--GAME INTERFACE-->
    <transition name="">
    <div class="modal-dialog" v-if="lotteryModalInterface == 1">
      <div class="modal-content modal__bg--color" data-bs-theme="dark">
        <button type="button" class="btn-close position-absolute end-0 p-2" data-bs-dismiss="modal"
          aria-label="Close"></button>
        <div class="modal-body modal__bg--img">
          <div class="container ">
            <div class="row text-center">
              <div class="col-12 justify-content-center p-4">
                <img src="../assets/images/campaigns/travel-2025/title.png" alt="" class="w-50">
              </div>
              <span class="fw-bold text-white">YOUR YEAR OF ADVENTURE</span>
              <div class="col-12 text-white text-uppercase lh-1 fw-bolder py-3 lbl-01">
                  CLICK TO FIND YOUR <br> ADVENTURE IN THE BAG!
              </div>
              <div class="col-12 px-lg-5">
                <img src="../assets/images/campaigns/travel-2025/call-to-action.png" alt="" class="w-50" :class="[isTriggered ? 'swing--triggered-state' : 'swing--initial-state']">
              </div>
              <div class="col-3 text-end align-self-end">
                <img src="../assets/images/campaigns/travel-2025/cursor.png" alt="" class="w-75">
              </div>
              <div class="col-6">
                <div class="btn btn-click rounded-pill py-0 mt-4" @click="play()">CLICK TO OPEN</div>
              </div>
              <div class="col-3">
              </div>
              <div class="col-8 terms-lbl text-start align-self-center pt-4">
                <span>Does not apply with other promotions.</span> <br>
                <span>Valid with the purchase of a</span> <br>
                <span>Vacation Package to Mexico.</span> <br>
                <span>*Only with the purchase of a $599 package.</span> <br>
              </div>
              <div class="col-4 pt-4 text-white">
                <img src="../assets/images/campaigns/travel-2025/logo.png" alt="" class="w-75">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>

    <!--PRIZE INTERFACE-->
    <transition name="fade">
    <div class="modal-dialog" v-if="lotteryModalInterface == 2">
      <div class="modal-content modal-prize__bg--img rounded-0">
        <div class="modal-header">
          <div class="col-12 d-flex justify-content-center modal-title--prize text-center" >AMAZING! <br> YOU'RE PACKING </div>
          <div data-bs-theme="dark">
            <button type="button" class="btn-close position-absolute end-0 p-3 top-0 " data-bs-dismiss="modal"
              aria-label="Close"></button>
          </div>
        </div>
        <div class="modal-body ">
          <div class="container">
            <div class="row text-center">
              <div class="col-12 justify-content-center p-4 py-5">
                <img :src="prize.imgUrl" alt="" class="w-75">
              </div>
              <div class="col-12 text-white text-uppercase lh-1 fw-bolder pb-4 lbl-condition">
                *Valid with a of a vacation package to Mexico
              </div>
              <div class="col-12">
                <TheLotteryForm :prizeCode="prize.code" :prizeName="prize.name" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </transition>
  </div>
</template>

<script>
import TheLotteryForm from './TheLotteryForm.vue';
import Confetti from 'canvas-confetti'

export default {
  data() {
    return {
      title: 'The Lottery',
      lotteryModalInterface: "1",
      isTriggered: false,
      countdownTimer: {
        days: null,
        hours: null,
        minutes: null,
        seconds: null,
        isEnded: null,
        endDate: new Date('2024-12-31T23:59:59').getTime(),
        dDisplay: "",
        hDisplay: "",
        mDisplay: "",
        sDisplay: ""
      },
      prize:
      {
        name: '',
        code: '',
        imgUrl: '',
      },
    }
  },
  components: {
    TheLotteryForm
  },
  methods: {
    showModal() {
      let bannerModal = document.querySelector('#modalLottery', { backdrop: false });
      console.log(bannerModal)
      //eslint-disable-next-line
      const bannerModalInstance = new bootstrap.Modal(bannerModal);
      bannerModalInstance.show();
    },
    play() {
      this.isTriggered = true;
      setTimeout(() => {
        this.lotteryModalInterface = 2;
        this.getConfetti();
      }, 500);
     
    },
    updateRemaining(distance) {
      this.countdownTimer.days = Math.floor(distance / (1000 * 60 * 60 * 24))
      this.countdownTimer.dDisplay = this.countdownTimer.days > 0 ? (this.countdownTimer.days < 10 ? "0" + this.countdownTimer.days : this.countdownTimer.days) : "00";

      this.countdownTimer.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      this.countdownTimer.hDisplay = this.countdownTimer.hours > 0 ? (this.countdownTimer.hours < 10 ? "0" + this.countdownTimer.hours : this.countdownTimer.hours) : "00";

      this.countdownTimer.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
      this.countdownTimer.mDisplay = this.countdownTimer.minutes > 0 ? (this.countdownTimer.minutes < 10 ? "0" + this.countdownTimer.minutes : this.countdownTimer.minutes) : "00";

      this.countdownTimer.seconds = Math.floor((distance % (1000 * 60)) / 1000)
      this.countdownTimer.sDisplay = this.countdownTimer.seconds > 0 ? (this.countdownTimer.seconds < 10 ? "0" + this.countdownTimer.seconds : this.countdownTimer.seconds) : "00";
    },
    tick() {
      const currentTime = new Date()
      const distance = Math.max(this.countdownTimer.endDate - currentTime, 0)
      this.updateRemaining(distance)

      if (distance === 0) {
        clearInterval(this.timer)
        this.countdownTimer.isEnded = true
      }
    },
    setRandomNumber(max) {
      return Math.floor(Math.random() * max);
    },
    setPrize() {
      switch (this.setRandomNumber(4)) {
        case 0:
        this.prize.code = '#VAL40CITIES',
        this.prize.name = '40 Cities Certificate',
            this.prize.imgUrl = require('@/assets/images/campaigns/travel-2025/prizes/prize-01.png')
          break;
        case 1:
        this.prize.code = '#VALEXTRAN',
        this.prize.name = '1 Free Extra Night',
            this.prize.imgUrl = require('@/assets/images/campaigns/travel-2025/prizes/prize-02.png')
          break;
        case 2:
        this.prize.name = '$50 usd DISCOUNT',
        this.prize.code = '#VAL50DIS',
            this.prize.imgUrl = require('@/assets/images/campaigns/travel-2025/prizes/prize-03.png')
          break;
        case 3:
        this.prize.code = '#VAL1OODIS',
        this.prize.name = '$100 usd DISCOUNT',
            this.prize.imgUrl = require('@/assets/images/campaigns/travel-2025/prizes/prize-04.png')
          break;
        case 4:

        this.prize.code = '#VAL150DIS'
        this.prize.name = '$150 usd DISCOUNT',
            this.prize.imgUrl = require('@/assets/images/campaigns/travel-2025/prizes/prize-05.png')
          break;
        default:
          break;
      }
    },
  },
  computed:
  {
    getConfetti() {
      Confetti({
        particleCount: 100,
        spread: 70,
        origin: { y: 0.6 },
        zIndex: 2000,
        shapes: ['circle'],
        colors: ['#f75590', '#605f87', '#56c95e']
      })
    }
  },
  mounted() {
    // this.setPrize()
    // this.showModal();
    //  this.tick()
    //  this.timer = setInterval(this.tick.bind(this), 1000)
  },
  destroy() {
    clearInterval(this.timer)
  }
}
</script>

<style scoped>
.modal__bg--color {
  background-color: black !important;
}

.coutdown__bg--color {
  background-color: #d8d8d8;
}

.countdown-lbl__bg--color {
  background: rgb(178, 178, 178);
  background: linear-gradient(90deg, rgba(178, 178, 178, 1) 0%, rgba(193, 166, 120, 1) 12%, rgba(209, 153, 59, 1) 47%, rgba(201, 160, 90, 1) 89%, rgba(178, 178, 178, 1) 100%);
  margin-top: .3rem;
}

.coutdown__bg--color {
  background: rgb(216, 216, 216);
  background: linear-gradient(180deg, rgba(216, 216, 216, 1) 0%, rgba(208, 208, 208, 1) 39%, rgba(196, 196, 196, 1) 39%, rgba(178, 178, 178, 1) 100%);
  color: white;
}

.modal-prize__bg--img {
  background-image: url('../assets/images/campaigns/travel-2025/bg-prize-img.png');
  background-size: cover;
}


.digits {
  color: black;
  font-size: 2.5rem;
  font-weight: 700 !important;
  font-family: 'Oswald', sans-serif;
  background: rgb(242, 239, 234);
  background: linear-gradient(180deg, rgba(242, 239, 234, 1) 0%, rgba(205, 201, 198, 1) 51%, rgba(242, 239, 234, 1) 39%, rgba(205, 201, 198, 1) 100%);
  border-radius: .5rem;
  padding-right: .3rem;
  padding-left: .3rem;
}

.btn-click {
  background-color: #FFF;
  color: #006f8b;
  box-shadow: 0px 12px 0px 7px rgba(156, 213, 23, 0.75);
  -webkit-box-shadow: 0px 9px 0px -2px rgba(156, 213, 23, 0.75);
  -moz-box-shadow: 0px 9px 0px -2px rgba(156, 213, 23, 0.75);
  font-family: Bebas Neue;
  font-size: 2rem;
  border: solid 1px #006f8b;
}

.btn-click:hover {
  background-color: #FFF;
  color: #006f8b;
  box-shadow: 0px 12px 0px 7px rgba(156, 213, 23, 0.75);
  -webkit-box-shadow: 0px 9px 0px -2px rgba(156, 213, 23, 0.75);
  -moz-box-shadow: 0px 9px 0px -2px rgba(156, 213, 23, 0.75);
  font-family: Bebas Neue;
  font-size: 2rem;
  border: solid 1px #006f8b;
}

.btn-close {
  background-color: transparent !important;
}

.terms-lbl {
  font-family: "Montserrat", sans-serif;
  font-optical-sizing: auto;
  font-weight: 600;
  font-style: normal;
  position: relative;
  z-index: 3 !important;
  color: white;
  font-size: .5rem;
}

.modal__bg--img {
  background-image: url('../assets/images/campaigns/travel-2025/bg-image.jpg');
  background-size: cover;
  background-repeat: no-repeat;
}

.lbl-01 {
  font-weight: bolder !important;

  color: #f2efe8;
  font-size: 1.5rem;
}

.modal-header {
  /* background: rgb(216, 182, 119);
  background: linear-gradient(90deg, rgba(216, 182, 119, 1) 0%, rgba(162, 120, 54, 1) 100%); */
  background-color: transparent;
  border: none !important;
  border-radius: 0 !important;
}

.modal-title--prize {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  font-size: 2rem;
  color: white;
}

.lbl-condition {
  font-size: .8rem;
}

.modal-lbl-footer {
  font-family: "Montserrat", sans-serif;
  font-weight: 800;
  font-size: 1.3rem;
  color: white;
}

.modal__footer-bg--color {
  background: linear-gradient(90deg, rgba(216, 182, 119, 1) 0%, rgba(162, 120, 54, 1) 100%);
}

/* ANIMATIONS*/
.fadeOut-enter-from,
.fadeOut-leave-to {
  opacity: 0;
}

.fadeIn-enter-active,
.fadeIn-leave-active {
  transition: opacity 1.5s ease-out;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 1.5s ease-out;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.swing--triggered-state {
  animation: swing ease-in-out .1s infinite alternate;
  transform-origin: center -20px;
  float: center;

}

.swing--initial-state {
  animation: swing ease-in-out 1s infinite alternate;
  transform-origin: center -20px;
  float: center;
}

@keyframes swing {
  0% {
    transform: rotate(3deg);
  }

  100% {
    transform: rotate(-3deg);
  }
}
</style>
